import { RootState } from '../store';
import { ToastsState } from './toasts.state';

export const selectToasts = (state: RootState): ToastsState => state.toasts;
